import { createContext, useContext, useState, useCallback } from "react";
import { EmailCaptureModal } from "./EmailCaptureModal";

const EmailCaptureContext = createContext();

export const useEmailCapture = () => {
  const context = useContext(EmailCaptureContext);
  if (!context) {
    throw new Error("useEmailCapture must be used within EmailCaptureProvider");
  }
  return context;
};

export const EmailCaptureProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = useCallback(() => {
    setIsOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setIsOpen(false);
  }, []);

  return (
    <EmailCaptureContext.Provider value={{ openModal, closeModal }}>
      {children}
      <EmailCaptureModal isOpen={isOpen} onClose={closeModal} />
    </EmailCaptureContext.Provider>
  );
};

export default EmailCaptureProvider;
